<template>
  <div class="font-weight-bold">
    <div class="d-flex justify-center">
      <v-progress-circular :value="percentage" rotate="-90" :size="size * factor" :width="width" :color="color">{{percentage}}%
      </v-progress-circular>
    </div>
    <div class="text-xs-center pt-2" :class="`${color}--text`">{{label}} ({{value}})</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    percentage: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      default: 10
    },
    width: {
      type: Number,
      default: 5
    },
    factor: {
      type: Number,
      default: 1
    },
    color: {
      type: String,
      default: '#2196F3'
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style></style>
